var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "live_class",
              label: _vm.$t("live_class"),
              icon: "fas fa-chalkboard-teacher"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-md q-pb-xl q-mt-md",
              attrs: { name: "live_class" }
            },
            [
              _c(
                "div",
                [
                  _vm.$q.platform.is.desktop
                    ? _c("div", { staticClass: "row gutter-sm" }, [
                        _c("div", { staticClass: "col-sm-11" }, [
                          _c("p", { staticClass: "q-title" }, [
                            _vm._v(_vm._s(_vm.title))
                          ]),
                          _c(
                            "p",
                            { staticClass: "q-body-1 text-weight-light" },
                            [_vm._v(_vm._s(_vm.description))]
                          ),
                          _c(
                            "p",
                            { staticClass: "q-body-1 text-weight-light" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("timezone") + ": " + _vm.timezone)
                              )
                            ]
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "col-sm-1 cursor-pointer",
                            on: {
                              click: function($event) {
                                return _vm.showCertificate()
                              }
                            }
                          },
                          [
                            _c(
                              "vc-donut",
                              {
                                attrs: {
                                  sections: _vm.sections,
                                  size: 100,
                                  unit: "%"
                                }
                              },
                              [
                                _vm.user_progress < 100 &&
                                _vm.live_class_user_result_status != 1 &&
                                _vm.live_class_user_result_status != 2
                                  ? _c("h6", { staticClass: "text-primary" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.getPercentage(_vm.user_progress)
                                          ) +
                                          "%\n                            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.user_progress == 100 ||
                                _vm.live_class_user_result_status == 1 ||
                                _vm.live_class_user_result_status == 2
                                  ? _c("q-icon", {
                                      attrs: {
                                        name: _vm.getResult,
                                        color: _vm.getResultColor,
                                        size: "2rem"
                                      }
                                    })
                                  : _vm._e(),
                                _vm.live_class_user_result_status == 2
                                  ? _c("q-tooltip", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("you_were_reproved_in") +
                                              " " +
                                              _vm.live_class_user_result_date
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm.$q.platform.is.mobile
                    ? _c("div", { staticClass: "row gutter-xs" }, [
                        _c("div", { staticClass: "col-xs-10" }, [
                          _c("p", { staticClass: "q-title" }, [
                            _vm._v(_vm._s(_vm.title))
                          ])
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-2 cursor-pointer",
                            on: {
                              click: function($event) {
                                return _vm.showCertificate()
                              }
                            }
                          },
                          [
                            _c(
                              "vc-donut",
                              {
                                attrs: {
                                  sections: _vm.sections,
                                  size: 100,
                                  unit: "%"
                                }
                              },
                              [
                                _vm.user_progress < 100 &&
                                _vm.live_class_user_result_status != 1 &&
                                _vm.live_class_user_result_status != 2
                                  ? _c("h6", { staticClass: "text-primary" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.getPercentage(_vm.user_progress)
                                          ) +
                                          "%\n                            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.user_progress == 100 ||
                                _vm.live_class_user_result_status == 1 ||
                                _vm.live_class_user_result_status == 2
                                  ? _c("q-icon", {
                                      attrs: {
                                        name: _vm.getResult,
                                        color: _vm.getResultColor,
                                        size: "2rem"
                                      }
                                    })
                                  : _vm._e(),
                                _vm.live_class_user_result_status == 2
                                  ? _c("q-tooltip", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("you_were_reproved_in") +
                                              " " +
                                              _vm.live_class_user_result_date
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("div", { staticClass: "col-xs-12 col-sm-11" }, [
                          _c(
                            "p",
                            { staticClass: "q-body-1 text-weight-light" },
                            [_vm._v(_vm._s(_vm.description))]
                          ),
                          _c(
                            "p",
                            { staticClass: "q-body-1 text-weight-light" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("timezone") + ": " + _vm.timezone)
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "row reverse gutter-sm q-mt-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-2" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            label: _vm.$t("back"),
                            color: "primary",
                            icon: "fas fa-chevron-left"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({ name: "live_classes" })
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "q-tabs",
                    {
                      staticClass: "q-mt-md",
                      attrs: {
                        color: "primary",
                        "underline-color": "secondary",
                        align: "justify"
                      },
                      model: {
                        value: _vm.tab_live_class,
                        callback: function($$v) {
                          _vm.tab_live_class = $$v
                        },
                        expression: "tab_live_class"
                      }
                    },
                    [
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          name: "live_classes",
                          label: _vm.$q.platform.is.desktop
                            ? "" + _vm.$t("live_class")
                            : "",
                          icon: "fas fa-chalkboard-teacher"
                        },
                        slot: "title"
                      }),
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          name: "reaction_test",
                          label: _vm.$q.platform.is.desktop
                            ? "" + _vm.$t("reaction_test")
                            : "",
                          icon: "fas fa-clipboard-check"
                        },
                        slot: "title"
                      }),
                      _c(
                        "q-tab-pane",
                        {
                          staticClass: "q-px-md q-pb-md",
                          attrs: { name: "live_classes" }
                        },
                        [
                          _vm.$q.platform.is.desktop
                            ? _c("q-table", {
                                ref: "table",
                                staticClass: "shadow-0",
                                attrs: {
                                  pagination: _vm.server_pagination,
                                  data: _vm.activities,
                                  columns: _vm.columns,
                                  loading: _vm.loading,
                                  "row-key": "id",
                                  "no-data-label": _vm.$t("no_data_avaliable"),
                                  "no-results-label": _vm.$t(
                                    "no_results_found"
                                  ),
                                  "loading-label": _vm.$t("loading_data"),
                                  "rows-per-page-label": _vm.$t(
                                    "items_per_page"
                                  ),
                                  "rows-per-page-options": [0],
                                  "hide-bottom": ""
                                },
                                on: {
                                  "update:pagination": function($event) {
                                    _vm.server_pagination = $event
                                  },
                                  request: _vm.requestActivities
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function(props) {
                                        return _c(
                                          "q-tr",
                                          { attrs: { props: props } },
                                          _vm._l(props.cols, function(col) {
                                            return _c(
                                              "q-th",
                                              {
                                                key: col.name,
                                                attrs: { props: props }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(_vm.$t(col.label)) +
                                                    "\n                                "
                                                )
                                              ]
                                            )
                                          }),
                                          1
                                        )
                                      }
                                    },
                                    {
                                      key: "body",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "q-tr",
                                            {
                                              class: _vm.getRowClass(props.row),
                                              attrs: { props: props }
                                            },
                                            [
                                              _c(
                                                "q-td",
                                                {
                                                  key: "type_title",
                                                  attrs: { props: props }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        props.row.type_title
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "q-td",
                                                {
                                                  key: "type_slug",
                                                  attrs: { props: props }
                                                },
                                                [
                                                  _c("q-icon", {
                                                    staticClass: "q-mr-sm",
                                                    attrs: {
                                                      name: _vm.getIcon(
                                                        props.row.type_slug
                                                      ),
                                                      size: "1rem"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm.getType(
                                                            props.row.type_slug
                                                          )
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "q-td",
                                                {
                                                  key: "platform_type",
                                                  attrs: { props: props }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.getLiveClassPlatformTypes(
                                                          props.row
                                                            .platform_type
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "q-td",
                                                {
                                                  key: "score",
                                                  attrs: { props: props }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(props.row.score) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "q-td",
                                                {
                                                  key: "user_watch",
                                                  attrs: {
                                                    props: props,
                                                    "auto-width": ""
                                                  }
                                                },
                                                [
                                                  props.row.is_blocked
                                                    ? _c("q-icon", {
                                                        attrs: {
                                                          name: "fas fa-ban",
                                                          size: "1.5rem",
                                                          color: "negative"
                                                        }
                                                      })
                                                    : props.row.is_approved
                                                    ? _c("q-icon", {
                                                        attrs: {
                                                          name:
                                                            "far fa-check-circle",
                                                          size: "1.5rem",
                                                          color: "positive"
                                                        }
                                                      })
                                                    : props.row.type_slug !==
                                                      "live_class"
                                                    ? _c("q-icon", {
                                                        attrs: {
                                                          name: "far fa-circle",
                                                          size: "1.5rem",
                                                          color: "primary"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _c(
                                                "q-td",
                                                {
                                                  key: "actions",
                                                  attrs: { props: props }
                                                },
                                                [
                                                  _c("q-btn", {
                                                    staticClass: "full-width",
                                                    attrs: {
                                                      color: "primary",
                                                      label: _vm.$t(
                                                        _vm.getLabelBtn(
                                                          props.row
                                                        )
                                                      ),
                                                      icon: _vm.getIconBtn(
                                                        props.row
                                                      ),
                                                      disable: _vm.getDisableButton(
                                                        props.row
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.btnClicked(
                                                          props.row
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2240926143
                                )
                              })
                            : _vm._e(),
                          _vm._l(_vm.activities, function(activity, index) {
                            return _vm.$q.platform.is.mobile
                              ? _c(
                                  "q-card",
                                  {
                                    key: index,
                                    staticClass: "bg-grey-1 q-mt-md",
                                    class: _vm.getRowClass(activity)
                                  },
                                  [
                                    _c(
                                      "q-card-main",
                                      { staticClass: "relative-position" },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "line-card bg-primary absolute-top"
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row gutter-sm vertical-middle"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-9" },
                                              [
                                                _c(
                                                  "p",
                                                  [
                                                    activity.is_blocked
                                                      ? _c("q-icon", {
                                                          attrs: {
                                                            name: "fas fa-ban",
                                                            size: "1rem",
                                                            color: "negative"
                                                          }
                                                        })
                                                      : activity.is_approved
                                                      ? _c("q-icon", {
                                                          attrs: {
                                                            name:
                                                              "far fa-check-circle",
                                                            size: "1rem",
                                                            color: "positive"
                                                          }
                                                        })
                                                      : activity.type_slug !==
                                                        "live_class"
                                                      ? _c("q-icon", {
                                                          attrs: {
                                                            name:
                                                              "far fa-circle",
                                                            size: "1.5rem",
                                                            color: "primary"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "q-ml-sm q-subheading"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            activity.type_title
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-3 text-right"
                                              },
                                              [
                                                _c("q-icon", {
                                                  attrs: {
                                                    name: _vm.getIcon(
                                                      activity.type_slug
                                                    ),
                                                    size: "3rem",
                                                    color: "secondary"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c("q-card-separator"),
                                    _c(
                                      "q-card-actions",
                                      [
                                        _c("q-btn", {
                                          staticClass: "full-width",
                                          attrs: {
                                            color: "primary",
                                            label: _vm.$t(
                                              _vm.getLabelBtn(activity)
                                            ),
                                            icon: _vm.getIconBtn(activity),
                                            disable: _vm.getDisableButton(
                                              activity
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.btnClicked(activity)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      ),
                      _c(
                        "q-tab-pane",
                        {
                          staticClass: "q-px-md q-pb-xl q-mt-md",
                          attrs: { name: "reaction_test" }
                        },
                        [_c("reaction-test")],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm.show_modal_class_room
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": { minWidth: "100vw", minHeight: "100vh" },
                "no-backdrop-dismiss": "",
                "no-esc-dismiss": ""
              },
              on: { hide: _vm.hideModalClassRoom },
              model: {
                value: _vm.show_modal_class_room,
                callback: function($$v) {
                  _vm.show_modal_class_room = $$v
                },
                expression: "show_modal_class_room"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            return _vm.hideModalClassRoom()
                          }
                        }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.selected_live_class.title) +
                            "\n                "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm.show_modal_class_room
                    ? _c("class-room", {
                        attrs: { room: _vm.live_class_room },
                        on: { hideModalClassRoom: _vm.hideModalClassRoom }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "90vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_modal_test,
            callback: function($$v) {
              _vm.show_modal_test = $$v
            },
            expression: "show_modal_test"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideModalTest()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.test.title) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _vm.test
                ? _c("test", {
                    attrs: { test: _vm.test },
                    on: { clearTest: _vm.hideModalTest }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { "stack-buttons": "", "prevent-close": "" },
          on: {
            cancel: function($event) {
              _vm.show_meet_dialog = false
            },
            hide: function($event) {
              _vm.show_meet_dialog = false
            }
          },
          model: {
            value: _vm.show_meet_dialog,
            callback: function($$v) {
              _vm.show_meet_dialog = $$v
            },
            expression: "show_meet_dialog"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("window_blocked")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("browser_window_blocked_click")) +
                "\n            "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.live_class_external_url,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [_vm._v(_vm._s(_vm.$t("here")))]
            ),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("to_access_the_class")) +
                "\n            "
            )
          ])
        ]
      ),
      _vm.show_certificate
        ? _c("certificate", {
            attrs: { show: _vm.show_certificate, data: _vm.certificate_data },
            on: { hideCertificate: _vm.hideCertificate }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }